import type { AdminReportConfiguration } from '@core/account-types';
import { createSingleEntityStore } from '@core/ngrx-legacy';

import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<AdminReportConfiguration | null>()(EntityStoreKey.reportConfiguration);

export {
  actions as ReportConfigurationActions,
  selectors as ReportConfigurationSelectors,
  reducer as ReportConfigurationReducer,
  namespace as ReportConfigurationNamespace,
};
